module.exports = __webpack_public_path__ + "media/images/landkit/screenshots/landkit/account/signup-modal-vertical-b1cadeb8b33e7dbdf176a0669c92ca15.jpg";